import ModalManager from 'global/modal/ModalManager';

class NotifyMeWhenInStockModalManager extends ModalManager {
	showModal() {
		super.showModal();
	}

	setupResponseHtml(data) {
		super.setupResponseHtml(data);
	}
}

export default NotifyMeWhenInStockModalManager;
